var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelluar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 5.25V13.75C14.6 17.15 13.75 18 10.35 18H5.25C1.85 18 1 17.15 1 13.75V5.25C1 1.85 1.85 1 5.25 1H10.35C13.75 1 14.6 1.85 14.6 5.25Z",
    stroke: "#F82643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49998 3.97656H6.09998",
    stroke: "#F82643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80004 15.5334C8.52768 15.5334 9.11754 14.9436 9.11754 14.2159C9.11754 13.4883 8.52768 12.8984 7.80004 12.8984C7.07241 12.8984 6.48254 13.4883 6.48254 14.2159C6.48254 14.9436 7.07241 15.5334 7.80004 15.5334Z",
    stroke: "#F82643",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelluar);
export default __webpack_public_path__ + "static/media/celluar.21d551382a6a7aebc4735e45efd88c9a.svg";
export { ForwardRef as ReactComponent };